<template>
    <component :is="svgFile" v-if="name" />
</template>

<script>
    import { debugLog } from '@/utils/index.js';

    // Use import.meta.glob with eager to synchronously load all SVG components at build time.
    // vite-svg-loader transforms each .svg into a Vue component exposed as the default export.
    const svgModules = import.meta.glob('@/assets/svg/**/*.svg', { eager: true });

    export default {
        props: {
            name: {
                type: String,
                required: true,
            },
        },

        computed: {
            svgFile() {
                if (!this.name) {
                    return '';
                }

                // Build the path to match the glob keys (e.g., "/src/assets/svg/illustrations/calendar.svg")
                const path = `/src/assets/svg/${this.name}.svg`;

                if (svgModules[path]) {
                    return svgModules[path].default || svgModules[path];
                }

                debugLog(`[ActivixSvg] SVG not found: ${this.name}`);

                return '';
            },
        },
    };
</script>
